<mat-card class="mat-elevation-z0">
    <mat-card-title appLocalizationPopupDirective localizationCode="QuickLinks">
        <h2>{{ 'QuickLinks' | translate: {Default: "Quick Links"} }}</h2>
    </mat-card-title>

    <mat-card-content role="region" [attr.aria-label]="'Quick Links' | translate: {Default: 'Quick Links'}">
        <div *ngIf="loading" class="loading-container" aria-live="polite">
            <ngx-skeleton-loader
                    count="5"
                    appearance="circle"
                    [theme]="{
                    'height.px': 50,
                    'width.px': 50
                    }">
                </ngx-skeleton-loader>
            <p class="sr-only">{{ 'Loading quick links' | translate: {Default: 'Loading quick links'} }}</p>
        </div>

        <div *ngIf="!loading">
            <div class="quick-links-container">
                <div *ngIf="quickLinks.length === 0" appLocalizationPopupDirective localizationCode="NoQuickLinks" aria-live="polite">
                    {{ 'NoQuickLinks' | translate: {Default: "No quick links available."} }}
                </div>

                <div *ngIf="quickLinks.length > 0" class="quick-links-list" role="list"
                    [attr.aria-label]="'Available quick links' | translate: {Default: 'Available quick links'}">
                    <div *ngFor="let link of quickLinks; let i = index" role="listitem">
                        <div
                            appPreventDoubleClick (throttledClick)="openQuickLink(link)" 
                            (keydown.enter)="openQuickLink(link)"
                            (keydown.space)="onQuickLinkSpace($event, link)"
                            class="quick-link" role="button" tabindex="0" [attr.aria-label]="getQuickLinkAriaLabel(link, i)"
                        >
                            <mat-icon class="quick-links-icon material-icons-outlined" aria-hidden="true">{{ link.icon }}</mat-icon>
                            <div class="title">{{ link.title }}</div>
                            <div class="description">{{ link.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>